<div class="container mx-auto">
  <div class="mt-8">

<div class="grid sm:grid-cols-2 grid-cols-1">
      <div class="col-span-1 md:mb-0 mb-3">
        <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">            
          {{ getUserFullName(selectedUser()) }}
        </h1>
      </div>
      <div class="col-span-1 sm:text-end text-center md:mb-0 mb-3 md:text-base text-sm flex gap-2 justify-end">

@if (isModuleAdmin && selectedUser()) {
          <p-button [label]="'userAdministration.addUserToCompany' | translate" icon="pi pi-plus"
            severity="primary" [disabled]="importableCompanies().length === 0 || isDetailLoading()"
            (onClick)="openImportDialog()" />
        }
            </div>
    </div>
    </div>
  <div class="mt-8">
    <p-panel [showHeader]="false">
      <gate-user-directory-company-table
        [companies]="registeredCompanies()"
        [loading]="isDetailLoading()"
        [isModuleAdmin]="isModuleAdmin"
        [showImpersonation]="!!selectedUser()?.payload?.cidaas?.cidaasSub"
        captionKey="userAdministration.allCustomers"
        [emptyMessageKey]="selectedUser() ? 'userAdministration.noRegisteredCompaniesFound' : 'userAdministration.noUserFound'"
        (impersonate)="impersonate(selectedUser()?.payload?.cidaas?.cidaasSub, $event)">
      </gate-user-directory-company-table>
    </p-panel>
  </div>
</div>

<gate-user-directory-import-dialog
  [visible]="isImportDialogVisible()"
  [user]="selectedUser()"
  [companies]="importableCompanies()"
  [isModuleAdmin]="isModuleAdmin"
  (visibleChange)="onImportDialogVisibleChange($event)"
  (imported)="onCompaniesImported($event)">
</gate-user-directory-import-dialog>
